import { BankAccountInfo } from '@square/dashboard-protos/models/squareup/deposits/api';
import { getLinkedBankAccountLabel } from '@banking/ui/utils/checking/utils';
import { getInitialPaginatedState, handleUserClickNextPageAction, handleUserClickPrevPageAction } from '@banking/ui/workflows/bank-accounts/pagination';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';

// State
// =============================================================================

export const INITIAL_STATE = {
  allRows: [],
  currentPage: 1,
  displayedRows: [],
  lastPage: 1,
  showPagination: false,
  externalBankAccountsHeadingTitle: ''
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});

// Action
// =============================================================================

export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["InitExternalBankAccounts"] = "EXTERNAL_BANK_ACCOUNTS/WORKFLOW_INIT";
  ActionType["UserClickNextPage"] = "EXTERNAL_BANK_ACCOUNTS/USER_CLICK_NEXT_PAGE";
  ActionType["UserClickPrevPage"] = "EXTERNAL_BANK_ACCOUNTS/USER_CLICK_PREV_PAGE";
  return ActionType;
}({});
// Action Creators
// =============================================================================

export const initExternalBankAccountsAction = merchantBankAccounts => ({
  type: ActionType.InitExternalBankAccounts,
  merchantBankAccounts
});
export const userClickNextPageAction = () => ({
  type: ActionType.UserClickNextPage
});
export const userClickPrevPageAction = () => ({
  type: ActionType.UserClickPrevPage
});

// Selectors
// =============================================================================
export const goNextPageDisabled = state => {
  return state.currentPage >= state.lastPage;
};
export const goPrevPageDisabled = state => {
  return state.currentPage <= 1;
};

// MISC
// =============================================================================

function getBankAccountState(bankAccountState, intl) {
  switch (bankAccountState) {
    case BankAccountInfo.BankAccountState.ACTIVE:
      return intl.t('banking.unifiedBankAccounts.bankAccountState.active');
    case BankAccountInfo.BankAccountState.AWAITING_2FA_CONFIRMATION:
      return intl.t('banking.unifiedBankAccounts.bankAccountState.awaiting2FA');
    case BankAccountInfo.BankAccountState.DISABLED:
      return intl.t('banking.unifiedBankAccounts.bankAccountState.disabled');
    case BankAccountInfo.BankAccountState.VERIFICATION_CANCELLED:
      return intl.t('banking.unifiedBankAccounts.bankAccountState.verificationCancelled');
    case BankAccountInfo.BankAccountState.VERIFICATION_IN_PROGRESS:
      return intl.t('banking.unifiedBankAccounts.bankAccountState.verificationInProgress');
    case BankAccountInfo.BankAccountState.FAILED:
    default:
      return intl.t('banking.unifiedBankAccounts.bankAccountState.failed');
  }
}
function getExternalBankAccountsHeadingTitle(countryCode, intl) {
  switch (countryCode) {
    case Country.JP:
      return intl.t('banking.unifiedBankAccounts.externalBankAccounts.heading.title.JP');
    default:
      return intl.t('banking.unifiedBankAccounts.externalBankAccounts.heading.title.default');
  }
}

// Update
// =============================================================================

function handleInitExternalBankAccountsAction(context, state, action) {
  const {
    merchantBankAccounts
  } = action;
  const externalBankAccountsHeadingTitle = getExternalBankAccountsHeadingTitle(context.countryCode, context.intl);
  const allRows = merchantBankAccounts.map(account => {
    return {
      bankLabel: getLinkedBankAccountLabel(account, context.intl),
      bankState: getBankAccountState(account.state, context.intl),
      bankInfo: account
    };
  });
  return [{
    ...getInitialPaginatedState(state, allRows),
    externalBankAccountsHeadingTitle
  }, null];
}
export const update = context => (state, action) => {
  switch (action.type) {
    case ActionType.InitExternalBankAccounts:
      return handleInitExternalBankAccountsAction(context, state, action);
    case ActionType.UserClickNextPage:
      return handleUserClickNextPageAction(state);
    case ActionType.UserClickPrevPage:
      return handleUserClickPrevPageAction(state);
  }
};